import { CSSProperties } from 'react'
import TableCell from '@mui/material/TableCell'
import { TableCellTooltip } from '@components/TableCellTooltip'

interface Props {
  cellData: any
  title?: string
  style?: CSSProperties
}

export const BasicCell = ({ cellData, title, style = {} }: Props) => {
  const TooltipWrapper = ({ title, children }) =>
    title ? <TableCellTooltip title={title}>{children}</TableCellTooltip> : children

  return (
    <TooltipWrapper title={title}>
      <TableCell
        component="td"
        scope="row"
        padding="normal"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...style,
        }}
      >
        {cellData}
      </TableCell>
    </TooltipWrapper>
  )
}
